<div class="container-filtre">
  <div class="title-modal">
    <span>Filtros</span>
    <span  class="close" (click)="close()">x</span>
  </div>
  <div class="filtros">
    <!-- <span>Fecha Inicio</span>
    <ion-item class="input-date">
      <ion-input type="date" [value]="'2022-02-10'" [(ngModel)]="filters.startDate"></ion-input>
    </ion-item>
    <span>Fecha Fin</span>
    <ion-item class="input-date">
      <ion-input type="date" [value]="'2023-02-10'" [(ngModel)]="filters.endDate"></ion-input>
    </ion-item> -->

    <ion-item class="select">
      <ion-label fill="outline">Campo :</ion-label>
      <ion-select interface="popover" [(ngModel)]="filters.field">
        <ion-select-option [value]="item.id" *ngFor="let item of fields">{{item.name}}</ion-select-option>
        
      </ion-select>
    </ion-item>

    <ion-item class="select ">
      <ion-label fill="outline">Estado de licencia:</ion-label>
      <ion-select interface="popover" [(ngModel)]="filters.is_active">
        <ion-select-option [value]="true" >Activa</ion-select-option>
        <ion-select-option [value]="false" >Inactiva</ion-select-option>
      </ion-select>
    </ion-item>
  </div>
  <div class="container-button">
    <div>
      <ion-button color="secondary" fill="outline" (click)="close()">Cancelar</ion-button>
      <ion-button color="secondary" (click)="confirm()">Filtrar</ion-button>
    </div>
  </div>
</div>

